/* Shared cart classification for the cross-sell features.
 *
 * Bags-only cart  -> offer a discount on shoes
 * Shoes-only cart -> offer a discount on a bag
 * Mixed cart      -> nothing
 *
 * Classification notes that matter more than the code:
 *  - product_type "Swag" covers bags AND socks, so it can never identify a bag.
 *    Bags come from a Liquid-rendered id list built from the bags collection.
 *  - Insurance (Route), gift cards, cards and bundles are ignored entirely: they
 *    never make a cart "mixed" and never count as a category on their own.
 *  - Gift-with-purchase lines are ignored the same way. The BOGOS app prefixes
 *    those titles with a gift emoji and "(100% off)", and they are also $0.
 *  So a cart holding two crossbody bags, Route insurance and a free GWP sock is
 *  a bags-only cart, which is what most real BANGS carts look like.
 *
 * Lives in its own file so the cart-page popup and the add-to-cart panel share
 * one implementation rather than drifting apart. Loaded deferred from the head,
 * so it is always defined before either consumer runs.
 */
(function () {
  'use strict';

  var GWP_TITLE_MARKERS = ['🎁', '(100% off)'];

  function readMap() {
    var el = document.getElementById('cc-cart-category-map');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function isIgnorable(item, map) {
    if (!item) return true;
    if (item.price === 0 || item.final_price === 0) return true;
    if ((map.ignoredTypes || []).indexOf(item.product_type) !== -1) return true;

    var title = item.product_title || item.title || '';
    for (var i = 0; i < GWP_TITLE_MARKERS.length; i++) {
      if (title.indexOf(GWP_TITLE_MARKERS[i]) !== -1) return true;
    }
    return false;
  }

  function classify(cart, map) {
    map = map || readMap() || {};
    var bagIds = map._bagSet || new Set((map.bagIds || []).map(Number));
    map._bagSet = bagIds;
    var shoeTypes = map.shoeTypes || [];

    var hasBag = false;
    var hasShoe = false;

    (cart.items || []).forEach(function (item) {
      if (isIgnorable(item, map)) return;

      if (bagIds.has(Number(item.product_id))) {
        hasBag = true;
      } else if (shoeTypes.indexOf(item.product_type) !== -1) {
        hasShoe = true;
      }
      // Socks, laces, stickers and anything else fall through: they are neither
      // a bag nor a shoe, so they neither trigger an offer nor block one. A
      // sock-only cart therefore shows nothing, which is the whole reason bags
      // are matched by id instead of by product type.
    });

    if (hasBag && !hasShoe) return { direction: 'bagsToShoes', total: cart.total_price };
    if (hasShoe && !hasBag) return { direction: 'shoesToBags', total: cart.total_price };
    return { direction: null, total: cart.total_price };
  }

  function warnIfTruncated(map) {
    if (!map) return;
    if (map.bagCount > (map.bagIds || []).length) {
      // Never let a truncated map misclassify in silence.
      console.warn(
        '[cross-sell] bags collection has ' +
          map.bagCount +
          ' products but only ' +
          map.bagIds.length +
          ' were rendered. Bags beyond the first 50 will be treated as neither bag nor shoe.'
      );
    }
  }

  window.CCCartClassify = {
    readMap: readMap,
    classify: classify,
    isIgnorable: isIgnorable,
    warnIfTruncated: warnIfTruncated
  };
})();
